// extracted by mini-css-extract-plugin
module.exports =  {"card":"da51a739f7--card--lpDw9","card__image":"da51a739f7--card__image--fsh_o","card__title":"da51a739f7--card__title--NHImn","card__item":"da51a739f7--card__item--TzrnZ"};